<div *ngIf="!isDesktop" class="top-input-modal safe-area-top">
  <app-video-modal-input
    [restaurant]="restaurant"
    [type]="type"
    (videoAdded)="onVideoAdded($event)"
  ></app-video-modal-input>
</div>
